import {
  fuseConfigurationsConstants,
  testConfigurationsConstants,
  provisionConfigurationsConstants,
} from "../_redux-constants";

export function configurationOptionsReducer(
  state = {
    // Fuse Configurations
    fuseConfigurationsLoading: false,
    fuseConfigurationsData: null,
    fuseConfigurationsError: null,

    //Test Configurations
    testConfigurationsLoading: false,
    testConfigurationsData: null,
    testConfigurationsError: null,

    // Provisioning Configurations
    provisionConfigurationsLoading: false,
    provisionConfigurationsData: null,
    provisionConfigurationsError: null,
  },
  action
) {
  switch (action.type) {
    // Fuse Configurations
    case fuseConfigurationsConstants.FUSE_CONFIGURATIONS_LOADING:
      return Object.assign({}, state, {
        fuseConfigurationsLoading: true,
        fuseConfigurationsError: null,
        fuseConfigurationsData: null,
      });
    case fuseConfigurationsConstants.FUSE_CONFIGURATIONS_SUCCESS:
      return Object.assign({}, state, {
        fuseConfigurationsLoading: false,
        fuseConfigurationsData: action.data,
      });
    case fuseConfigurationsConstants.FUSE_CONFIGURATIONS_FAILURE:
      return Object.assign({}, state, {
        fuseConfigurationsLoading: false,
        fuseConfigurationsData: null,
        fuseConfigurationsError: action.error,
      });

    // Test Configurations
    case testConfigurationsConstants.TEST_CONFIGURATIONS_LOADING:
      return Object.assign({}, state, {
        testConfigurationsLoading: true,
        testConfigurationsError: null,
        testConfigurationsData: null,
      });
    case testConfigurationsConstants.TEST_CONFIGURATIONS_SUCCESS:
      return Object.assign({}, state, {
        testConfigurationsLoading: false,
        testConfigurationsData: action.data,
      });
    case testConfigurationsConstants.TEST_CONFIGURATIONS_FAILURE:
      return Object.assign({}, state, {
        testConfigurationsLoading: false,
        testConfigurationsData: null,
        testConfigurationsError: action.error,
      });

    // Provisioning Configurations
    case provisionConfigurationsConstants.PROVISIONING_CONFIGURATIONS_LOADING:
      return Object.assign({}, state, {
        provisionConfigurationsLoading: true,
        provisionConfigurationsError: null,
        provisionConfigurationsData: null,
      });
    case provisionConfigurationsConstants.PROVISIONING_CONFIGURATIONS_SUCCESS:
      return Object.assign({}, state, {
        provisionConfigurationsLoading: false,
        provisionConfigurationsData: action.data,
      });
    case provisionConfigurationsConstants.PROVISIONING_CONFIGURATIONS_FAILURE:
      return Object.assign({}, state, {
        provisionConfigurationsLoading: false,
        provisionConfigurationsData: null,
        provisionConfigurationsError: action.error,
      });

    default:
      return state;
  }
}
